import honeyBee from './honey_bee.js'

export const pods = {
    honey_bee: honeyBee
}
